import { useState } from "react";
import { FaChevronUp } from "react-icons/fa";
import { Data } from "./AccordianFile";
import { FaAngleDown } from "react-icons/fa";

const QuizBoardLandingFAQSection = () => {
  const [open,setOpen]=useState(null);

  const toggleAnswer = (index) => {
      if(index===open){
        setOpen(null)
      }
      else{
        setOpen(index)
      }
  }

  return (
    <>
      <div className="row mx-0 py-5 QuizBoardLandingFAQSection">
        <div className="col-12 px-0">
          <h3 className="text-center text-white py-4">Frequently Asked <span>Questions</span></h3>
          <div className="px-lg-5">
            <div className="row mx-0 d-flex align-items-center justify-content-center">
              <div className="col-lg-10 px-4">
                {Data.map((data, index) => (
                  <div className="py-3" key={index}>
                    <div className="QuizBoardLandingFAQSection-box py-2 px-3">
                      <div className=" d-flex justify-content-between">
                        {index===open ? (
                          <h5 className="text-primary">{data.question}</h5>
                        ) : (
                          <h5 className="text-white">{data.question}</h5>
                        )}
                        <span
                          className=""
                          onClick={() => toggleAnswer(index)}
                        >
                          {index===open ? (
                            <span className="text-primary">
                              <FaChevronUp />{" "}
                            </span>
                          ) : (
                            <span className="text-white">
                              <FaAngleDown />
                            </span>
                          )}
                        </span>
                      </div>
                      <div className="">
                        {index===open && (
                          <p className="QuizBoardLandingFAQSection-answer text-white">
                            {data.answer}
                          </p> // Display answer if this question is open
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuizBoardLandingFAQSection;
